import { gql } from "@apollo/client";

export const RESET_PERF_LOGS = gql`
  mutation ResetPerfLogs($scope: String) {
    resetPerfLogs(scope: $scope) {
      deletedCount
      errors
    }
  }
`;

/**
 * The handoff: the timings as markdown, ready to paste to whoever — or whatever
 * — is going to make them smaller.
 *
 * A mutation and not a query because pressing the button changes what the next
 * reader knows: the rows it covered are stamped `copiedAt`. It answers with
 * those rows, so the list behind the button updates without a refetch.
 *
 * With `id` it is one operation in full, worst occurrence included; without, the
 * same filters the page is showing.
 */
export const COPY_PERF_REPORT = gql`
  mutation CopyPerfReport($id: ID, $limit: Int, $sort: String, $kind: String, $search: String) {
    copyPerfReport(id: $id, limit: $limit, sort: $sort, kind: $kind, search: $search) {
      report
      perfLogs {
        id
        copiedAt
      }
      errors
    }
  }
`;
